import axios from "./http";

export const getUsers = data => axios("users", { params: data });
export const getUserAPI = username => axios(`users/${username}`);
export const createUser = data => axios.post("users", data);
export const updateUserAPI = (username, data) =>
    axios.put(`users/${username}`, data);
export const deleteUserByName = data => axios.delete(`users/${data.id}`);
export const createPhoneCodeAPI = (username, data) =>
    axios.post(`users/${username}/phone`, data);
export const updateUserPhoneNumberAPI = (username, data) =>
    axios.put(`users/${username}/phone`, data);
export const createEmailCodeAPI = (username, data) =>
    axios.post(`users/${username}/email`, data);
export const updateUserEmailAPI = (username, data) =>
    axios.put(`users/${username}/email`, data);
export const getUserOrgsAPI = data => axios(`users/${data.name}/orgs`);
export const listUserTeamsAPI = (username, params) =>
    axios(`users/${username}/teams`, { params });
